const jobboxJsonHost = "__JOBBOX_JSON_HOST__";

export const jobboxApi = {
  get: async (
    keyword: string,
    site: string
  ): Promise<Response> => {
    const aditionalHeaders = new Headers();
    aditionalHeaders.append("Content-Type", "application/json");

    const fetchUrl = `${jobboxJsonHost}/${site}/${keyword}.json`;
    try {
      return await fetch(fetchUrl,
        {headers: aditionalHeaders}
      );
    } catch (error) {
      console.error(error);
      return new Response(null, { status: 500 });
    }
  }
};